import React, { useState } from 'react'
import TabTitle from './TabTitle'

const Tabs: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [selectedTab, setSelectedTab] = useState(0)

    return (
        <div>
            <ul className="order-details-nav">
                {children &&
                    Array.isArray(children) &&
                    children.map((item: React.ReactNode, index) => (
                        <>
                            {React.isValidElement(item) && (
                                <TabTitle
                                    key={index}
                                    title={item?.props.title}
                                    index={index}
                                    setSelectedTab={setSelectedTab}
                                    selectedTab={selectedTab}
                                />
                            )}
                        </>
                    ))}
            </ul>
            {(children as React.ReactNode[])[selectedTab]}
        </div>
    )
}

export default Tabs
